export const GroupChemiLogEvent = {
  GROUP_CHEMI_ALL_MEMBERS_VIEWED: {
    //그룹케미 결과 모두보기 클릭
    ga: 'group_chemi_all_members_viewed',
    amp: 'Group Chemi All Members - Viewed',
  },
  GROUP_CHEMI_RESULT_SHOW_ALL_CLICKED: {
    ga: 'group_chemi_result_show_all_clicked',
    amp: 'Group Chemi Result - Show All Clicked',
  },
  GROUP_CHEMI_LOADING_VIEWED: {
    ga: 'group_chemi_loading_viewed',
    amp: 'Group Chemi Loading - Viewed',
  },

  GROUP_CHEMI_CREATE_VIEWED: {
    ga: 'group_chemi_create_viewed',
    amp: 'Group Chemi Create - Viewed',
  },
  GROUP_CHEMI_GROUP_SELECT_SCREEN_VIEWED: {
    ga: 'group_chemi_group_select_screen_viewed',
    amp: 'Group Chemi - Group Select Screen Viewed',
  },

  GROUP_CHEMI_CREATE_ADD_BUTTON_CLICKED: {
    ga: 'group_chemi_create_add_button_clicked',
    amp: 'Group Chemi Create - Add Button Clicked',
  },

  GROUP_CHEMI_CREATE_SHARE_BUTTON_CLICKED: {
    ga: 'group_chemi_create_share_button_clicked',
    amp: 'Group Chemi Create - Share Button Clicked',
  },

  GROUP_CHEMI_NAME_INPUT_CLICKED: {
    ga: 'group_chemi_create_name_input_clicked',
    amp: 'Group Chemi Create - Name Input Clicked',
  },

  GROUP_CHEMI_NAME_INPUT_MODAL_VIEWED: {
    ga: 'group_chemi_name_input_modal_viewed',
    amp: 'Group Chemi Name Input Modal - Viewed',
  },

  GROUP_CHEMI_NAME_INPUT_MODAL_SUBMIT: {
    ga: 'group_chemi_name_input_modal_submit',
    amp: 'Group Chemi Name Input Modal - Submit',
  },

  GROUP_CHEMI_CREATE_MEMBER_LIST_BUTTON_CLICKED: {
    ga: 'group_chemi_create_member_list_button_clicked',
    amp: 'Group Chemi Create - Member List Button Clicked',
  },
  GROUP_CHEMI_MEMBER_LIST_VIEWED: {
    ga: 'group_chemi_member_list_viewed',
    amp: 'Group Chemi - Member List Viewed',
  },
  GROUP_CHEMI_MEMBER_LIST_SUBMIT: {
    ga: 'group_chemi_member_list_submit',
    amp: 'Group Chemi Member List - Submit',
  },
  GROUP_CHEMI_RESULT_VIEWED: {
    ga: 'group_chemi_result_viewed',
    amp: 'Group Chemi Result - Viewed',
  }, //그룹 케미 결과 화면 진입
  GROUP_CHEMI_RESULT_INVITE_VIEWED: {
    ga: 'group_chemi_result_invite_viewed',
    amp: 'Group Chemi Result - Invite Viewed',
  }, //그룹 케미 결과 초대화면 진입
  GROUP_CHEMI_RESULT_ANOTHER_CHEMI_BUTTON_CLICKED: {
    ga: 'group_chemi_result_another_chemi_button_clicked',
    amp: 'Group Chemi Result - Another Chemi Button Clicked',
  }, //그룹케미 결과 '다른 모임 MBTI 궁합보기' 배너 클릭
  GROUP_CHEMI_RESULT_INVITE_ACCEPT_BUTTON_CLICKED: {
    ga: 'group_chemi_result_invite_accept_button_clicked',
    amp: 'Group Chemi Result - Invite Accept Button Clicked',
  }, //'초대 수락하기' 버튼 클릭
  GROUP_CHEMI_RESULT_LOGIN_MODAL_IMPRESSION: {
    ga: 'group_chemi_result_login_modal_impression',
    amp: 'Group Chemi Result - Login Modal Impression',
  }, //로그인 모달 노출
  GROUP_CHEMI_RESULT_MBTI_NEEDDED_VIEWED: {
    ga: 'group_chemi_result_mbti_needed_viewed',
    amp: 'Group Chemi Result - MBTI Needed Viewed',
  }, //'성격유형이 필요해요'화면 노출
  GROUP_CHEMI_RESULT_MBTI_QUIZ_BUTTON_CLICKED: {
    ga: 'group_chemi_result_mbti_quiz_button_clicked',
    amp: 'Group Chemi Result - MBTI Quiz Button Clicked',
  }, //'성격유형 하러가기' 버튼 클릭
  GROUP_CHEMI_RESULT_IDEAL_MATCH_BUTTON_CLICKED: {
    ga: 'group_chemi_result_ideal_match_button_clicked',
    amp: 'Group Chemi Result - Ideal Match Button Clicked',
  }, //'이상형 MBTI 궁합보기' 버튼 클릭
  GROUP_CHEMI_RESULT_IDEAL_MATCH_CLOSE_BUTTON_CLICKED: {
    ga: 'group_chemi_result_ideal_match_close_button_clicked',
    amp: 'Group Chemi Result - Ideal Match Close Button Clicked',
  }, //'이상형 MBTI 궁합보기' 배너 제거 버튼 클릭
  GROUP_CHEMI_RESULT_DELETED_CHEMI_VIEWED: {
    ga: 'group_chemi_result_deleted_chemi_viewed',
    amp: 'Group Chemi Result - Deleted Chemi Viewed',
  }, //'삭제된 그룹' 화면 진입
  GROUP_CHEMI_GROUP_SELECT_VIEWED: {
    amp: 'Group Chemi Group Select - Viewed',
    ga: 'group_chemi_select_viewed',
  },
  GROUP_CHEMI_GROUP_SELECT_GROUP_CARD_CLICKED: {
    amp: 'Group Chemi Group Select - Group Card Clicked',
    ga: 'group_chemi_group_select_group_card_clicked',
  },
  GROUP_CHEMI_MBTI_REQUIREMENT_VIEWED: {
    amp: 'Group Chemi Requirement - Viewed',
    ga: 'group_chemi_requirement_viewed',
  },
  GROUP_CHEMI_MBTI_REQUIREMENT_SUBMIT: {
    amp: 'Group Chemi Requirement - Submit',
    ga: 'group_chemi_requirement_submit',
  },
  GROUP_CHEMI_MBTI_SUCCESS_VIEWED: {
    amp: 'Group Chemi Success - Viewed',
    ga: 'group_chemi_success_viewed',
  },
  GROUP_CHEMI_MBTI_SUCCESS_SUBMIT: {
    amp: 'Group Chemi Success - Submit',
    ga: 'group_chemi_success_submit',
  },
  GROUP_CHEMI_STAGING_VIEWED: {
    amp: 'Group Chemi Staging - Viewed',
    ga: 'group_chemi_staging_viewed',
  },
  GROUP_CHEMI_STAGING_UNKNOWN_FRIEND_INVITE_CLICKED: {
    amp: 'Group Chemi Staging - Unknown Friend Invite Clicked',
    ga: 'group_chemi_staging_unknown_friend_invite_clicked',
  },
  GROUP_CHEMI_INVITE_SHARE_BUTTON_CLICKED: {
    amp: 'Group Chemi - Invite Share Button Clicked',
    ga: 'group_chemi_invite_share_button_clicked',
  },
  GROUP_CHEMI_RESULT_RECOMMEND_QUIZ_CLICKED: {
    amp: 'Group Chemi Result - Recommend Quiz Clicked',
    ga: 'group_chemi_result_quiz_clicked',
  },

  GROUP_CHEMI_RESULT_HEADER_SHARE_BUTTON_CLICKED: {
    amp: 'Group Chemi Result - Header Share Button Clicked',
    ga: 'group_chemi_result_header_share_button_clicked',
  },

  GROUP_CHEMI_RESULT_HEADER_SHARE_CLICKED: {
    amp: 'Group Chemi Result - Header Share Clicked',
    ga: 'group_chemi_result_header_share_clicked',
  },

  GROUP_CHEMI_RESULT_SHARE_CLICKED: {
    amp: 'Group Chemi Result - Share Clicked',
    ga: 'group_chemi_result_share_clicked',
  },

  GROUP_CHEMI_RESULT_PERSONAL_CHEMI_BUTTON_CLICKED: {
    amp: 'Group Chemi Result - Personal Chemi Button Clicked',
    ga: 'group_chemi_result_personal_chemi_button_clicked',
  },

  HOME_GROUP_CHEMI_CLICKED: {
    amp: 'Home_group_chemi_clicked',
    ga: 'Home - Group Chemi Clicked',
  },
  // [그룹케미 생성] (웹)로그인 모달 진입
  GROUP_CHEMI_CREATE_LOGIN_MODAL_VIEWED: {
    amp: 'Group Chemi Create Login Modal - Viewed',
    ga: 'group_chemi_create_login_modal_viewed',
  },
  // [그룹케미 생성] (웹)로그인 모달 - 로그인 버튼 클릭
  GROUP_CHEMI_CREATE_LOGIN_MODAL_BUTTON_CLICKED: {
    amp: 'Group Chemi Create Login Modal - Button Clicked',
    ga: 'group_chemi_create_login_modal_button_clicked',
  },
  // [그룹케미 생성] (웹) 친구 초대하기 버튼 클릭
  GROUP_CHEMI_CREATE_INVITE_BUTTON_CLICKED: {
    amp: 'Group Chemi Create - Invite Button Clicked',
    ga: 'group_chemi_create_invite_button_clicked',
  },
  // [그룹케미 생성] (웹) QR CODE 버튼 클릭
  GROUP_CHEMI_CREATE_QR_CODE_BUTTON_CLICKED: {
    amp: 'Group Chemi Create - QR Code Button Clicked',
    ga: 'group_chemi_create_qr_code_button_clicked',
  },
  GROUP_CHEMI_MEMBER_LIST_QR_CODE_BUTTON_CLICKED: {
    amp: 'Group Chemi Member List - QR Code Button Clicked',
    ga: 'group_chemi_member_list_qr_code_button_clicked',
  },
}
